export const listIcons: { [key: string]: string } = {
  default: 'flat-line_box',
  MakanSiangReminderWfo: 'flat-line_alarm',
  PengajuanReimburse: 'flat-line_bill-dollar',
  tell_us: 'flat-line_campaign',
  PelaporanStatusInfraXl: 'flat-line_chip',
  PerpanjanganKontrakTim: 'flat-line_contract',
  PengajuanCoaching: 'flat-line_crane-truck-2',
  EvaluasiTim: 'flat-line_date-performance',
  PengajuanIzin: 'flat-line_departure',
  pengadaan: 'flat-line_files',
  BagiHasilProyek: 'flat-line_investment-dollar',
  EvaluasiSprint: 'flat-line_lari',
  KlaimTunjanganKesehatan: 'flat-line_medical-insurance',
  makan_siang_informasi: 'flat-line_menu-food',
  PencairanJpoint: 'flat-line_money-bag-dollar',
  PengajuanLembur: 'flat-line_pilates',
  Onboarding_tim: 'flat-line_play',
  Onboarding_pg: 'flat-line_play-octagon',
  penagihan_kpk: 'flat-line_receipt',
  penagihan_xl: 'flat-line_receipt-check',
  ProjectStatusReport: 'flat-line_report-pie-chart-11',
  TechleadReport: 'flat-line_report-pie-chart-6',
  Bonus: 'flat-line_reward',
  prosesKehadiranMakanSiang: 'flat-line_rice-cooker-2',
  SprintPlanning: 'flat-line_schedule',
  LaporanCapaianMagang: 'flat-line_star-2',
  PenyelesaianRekomendasiHasilEvaluasi: 'flat-line_taekwondo',
  PengajuanIzinOlehPeopleGrowth: 'flat-line_take-off',
  Reminder: 'flat-line_chronometer-3-second',
};
